jQuery(document).ready(function() {    
	if (jQuery('.slider-hunts-logo').length > 0) {
		jQuery('.slider-hunts-logo').slick({
			dots: false,
			arrows: false,
			infinite: true,
			speed: 800,
			slidesToShow: 6,
			autoplay: true,
			pauseOnHover: false,
			autoplaySpeed: 6000,
			swipe:true,
			swipeToSlide:true,
			responsive: [
				{
					breakpoint: 992.1,
					settings: {
						slidesToShow: 4,
				
					}
				},
				{
					breakpoint: 768.1,
					settings: {
						slidesToShow: 3,
				
					}
				},
			]
		});
	}
})